
import React from "react";
import { createRoot } from 'react-dom/client';
import "./index.css";
import promise from "redux-promise";
import createSagaMiddleware from "redux-saga";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import reducers from "./reducers";
import rootSaga from "./sagas";
import { loadState, saveState } from "./reducers/local-storage";
import { gnbDarkTheme } from "./shared-components/src/gnb-theme";
import "./index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import DynamicAppContainer from "./components/dynamic-app-container";
import Typography from "@material-ui/core/Typography";


// Saga

const persistedState = loadState();
const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = composeWithDevTools({});

const createStoreWithMiddleware = composeEnhancers(
  applyMiddleware(promise, sagaMiddleware)
)(createStore);

// Redux
const store = createStoreWithMiddleware(reducers, persistedState);

store.subscribe(() => {
  const auth = store.getState().authenticate;
  if (auth.remember) {
    saveState({
      authenticate: auth,
    });
  }
});

sagaMiddleware.run(rootSaga);

const muiTheme = createTheme(gnbDarkTheme);



const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <MuiThemeProvider theme={muiTheme}>
      <Typography component="div" color="textPrimary">
        <DynamicAppContainer />
      </Typography>
    </MuiThemeProvider>
  </Provider>
);

serviceWorkerRegistration.register();
